import { isNotOptional } from '@wix/seo-common-core';
import debounce from 'lodash/debounce';
import { getEditorCapabilitiesForHost } from '../../../../utils/editor-host-to-editor-type';
import { getFormattedColor, isClassicPageComponent, isClassicTextComponent, updateClassicBackgroundColor, updateClassicPageBackground, updateClassicTextAndBackgroundColor, updateClassicTextColor, updateEditor3BackgroundColor, updateEditor3TextColor, updateStudioBackgroundColor, updateStudioColor, updateStudioTextAndBackgroundColor } from './update-elements-color-utils';
const debouncedUpdateEditor3TextColor = debounce((component, className, color, a11yWizardAdapter, activeElement) => {
  updateEditor3TextColor(component, className, color, a11yWizardAdapter);
  activeElement == null || activeElement.focus();
}, 500);
export const hasSharedBaseComponentId = (elementId1, elementId2) => {
  const baseId1 = elementId1.split('__')[0];
  const baseId2 = elementId2.split('__')[0];
  return baseId1 === baseId2 && baseId1 !== elementId1 && elementId2.includes('__');
};
export const updateElementsColor = _ref => {
  let {
    textElement,
    ancestorElement,
    a11yWizardAdapter,
    getComponent,
    editorHost,
    activeElement
  } = _ref;
  const {
    usesClassBasedColorContrastUpdates,
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  const {
    setComponentStyle,
    setComponentDesign,
    setComponentData
  } = a11yWizardAdapter;
  if (!textElement && !ancestorElement) {
    throw new Error('At least one of the elements must be provided');
  }
  if (isNotOptional(textElement) && isNotOptional(ancestorElement) && textElement.id === ancestorElement.id) {
    const {
      id,
      color: textColor
    } = textElement;
    const {
      color: backgroundColor
    } = ancestorElement;
    const component = getComponent(id);
    const {
      type
    } = component;
    if (usesClassBasedColorContrastUpdates && textElement.className) {
      updateEditor3TextColor(component, textElement.className, textColor, a11yWizardAdapter);
      updateEditor3BackgroundColor(component, textElement.className, backgroundColor, a11yWizardAdapter);
      return;
    }
    if (isClassicTextComponent(type, usesClassicModalChrome)) {
      return updateClassicTextAndBackgroundColor(component, textColor, backgroundColor, setComponentData);
    }
    updateStudioTextAndBackgroundColor(component, textColor, backgroundColor, setComponentStyle);
    return;
  }
  if (textElement) {
    const {
      id,
      color
    } = textElement;
    const component = getComponent(id);
    const {
      type
    } = component;
    if (usesClassBasedColorContrastUpdates) {
      debouncedUpdateEditor3TextColor(component, textElement.className ?? '', color, a11yWizardAdapter, activeElement);
      return;
    }
    if (isClassicTextComponent(type, usesClassicModalChrome)) {
      return updateClassicTextColor(component, color, setComponentData);
    }
    updateStudioColor(component, color, setComponentStyle, setComponentDesign);
  }
  if (ancestorElement) {
    const {
      id,
      color,
      alpha
    } = ancestorElement;
    const component = getComponent(id);
    const {
      type
    } = component;
    if (usesClassBasedColorContrastUpdates) {
      return updateEditor3BackgroundColor(component, ancestorElement.className ?? '', color, a11yWizardAdapter);
    }
    if (isClassicTextComponent(type, usesClassicModalChrome)) {
      return updateClassicBackgroundColor(component, color, setComponentData);
    }
    if (isClassicPageComponent(type, usesClassicModalChrome)) {
      return updateClassicPageBackground(component, color, setComponentData, setComponentStyle);
    }
    const formattedColor = getFormattedColor(type, color, alpha);
    updateStudioBackgroundColor(component, formattedColor, setComponentStyle, setComponentDesign);
  }
};
//# sourceMappingURL=update-elements-color.js.map